import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LiveNursesEffects } from 'src/app/recruiting/candidates/live-nurses-new/store/effects';
import { JobDetailsEffects } from 'src/app/recruiting/jobs/details/components/store/effects/job-details.effects';
import { CandidateService } from '../candidates/candidate.service';
import { loadTeamInfo, loadTeamInfoFailure, loadTeamInfoSuccess } from './recruiting.actions';

@Injectable()
export class CandidateTeamInfoEffect {
    constructor(private readonly _actions$: Actions, private readonly _candidateService: CandidateService) {}

    getTeamInfo$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadTeamInfo),
            switchMap((action) => {
                return this._candidateService.getCandidateTeam(action.candidateId).pipe(
                    map((result) => loadTeamInfoSuccess({ teamInfo: result })),
                    catchError((error) => of(loadTeamInfoFailure({ error })))
                );
            })
        )
    );
}

export const RecruitingEffects = [...LiveNursesEffects, JobDetailsEffects, CandidateTeamInfoEffect];
